import React from 'react'
import cx from 'classnames'

import Image from 'components/_new/ui/Image/Image'

import s from './ProductImage.scss'

import pomImage from './images/pom.svg'


const ProductImage = ({ className, image }) => (
  <Image className={cx(s.image, className)} src={image || pomImage} w={200} mW={70} />
)


export default ProductImage
